<template>
  <div :class="sidebarClasses" :data-background-color="backgroundColor" :data-active-color="activeColor">
    <div class="sidebar-wrapper" id="style-3">
      <div class="logo">
        <img v-bind:src="logo" alt="" :class="logoClass">
      </div>
      <!-- <div class="logo">
        <a href="#" class="simple-text">
            <div class="logo-img">
                <img src="static/img/vue-logo.png" alt="">
            </div>
          Restaurant Portal
        </a>
      </div> -->
      <slot>
      </slot>
      <ul :class="navClasses">
        <!--By default vue-router adds an active class to each route link. This way the links are colored when clicked-->
        <router-link v-for="(link,index) in sidebarLinks" :to="link.path" tag="li" :ref="link.name">
          <a>
            <i :class="link.icon"></i>
            <p>{{link.name}}</p>
          </a>
        </router-link>
        <li class="router-link-exact-active"><a href="https://www.deliverlogic.com/npsupport/" target="_blank"><i class="ti-help-alt"></i> <p>Support</p></a></li>
      </ul>
      <!-- <moving-arrow :move-y="arrowMovePx">

      </moving-arrow> -->
      <div class="powered-by">
        <img src="static/img/powered_by.png" alt="">
      </div>
    </div>
  </div>
</template>
<script>
  // import MovingArrow from './MovingArrow.vue'

  if(localStorage.userInfo) {
    var userInfo = JSON.parse(localStorage.userInfo)
  }
  export default {
    props: {
      type: {
        type: String,
        default: 'sidebar',
        validator: (value) => {
          let acceptedValues = ['sidebar', 'navbar']
          return acceptedValues.indexOf(value) !== -1
        }
      },
      backgroundColor: {
        type: String,
        default: 'dlblue',
        validator: (value) => {
          let acceptedValues = ['white', 'black', 'darkblue', 'dlblue']
          return acceptedValues.indexOf(value) !== -1
        }
      },
      activeColor: {
        type: String,
        default: 'white',
        validator: (value) => {
          let acceptedValues = ['primary', 'info', 'success', 'warning', 'danger', 'white']
          return acceptedValues.indexOf(value) !== -1
        }
      },
      sidebarLinks: {
        type: Array,
        default: () => []
      }
    },
    components: {
      // MovingArrow
    },
    computed: {
      sidebarClasses () {
        if (this.type === 'sidebar') {
          return 'sidebar'
        } else {
          return 'collapse navbar-collapse off-canvas-sidebar'
        }
      },
      navClasses () {
        if (this.type === 'sidebar') {
          return 'nav'
        } else {
          return 'nav navbar-nav'
        }
      },
      /**
       * Styles to animate the arrow near the current active sidebar link
       * @returns {{transform: string}}
       */
      arrowMovePx () {
        return this.linkHeight * this.activeLinkIndex
      }
    },
    data () {
      return {
        linkHeight: 60,
        activeLinkIndex: 0,
        windowWidth: 0,
        isWindows: false,
        logo: 'static/img/dl-logo.png',
        hasAutoHeight: false,
        logoClass: userInfo.company.toLowerCase()
      }
    },
    methods: {
      findActiveLink () {
        this.sidebarLinks.find((element, index) => {
          let found = element.path === this.$route.path
          if (found) {
            this.activeLinkIndex = index
          }
          return found
        })
      },
      getLogo () {
        if (userInfo != undefined) {
          var company = userInfo.company.toLowerCase()
          if (company === 'hooters') {
            this.logo = 'static/img/hooters.png'
          } else if (company === 'applebees') {
            this.logo = 'static/img/applebees.png'
          } else if (company === 'fiveguys') {
            this.logo = 'static/img/five-guys.png'
          }
        }
      }
    },
    mounted () {
      this.findActiveLink()
      this.getLogo()
    },
    watch: {
      $route: function (newRoute, oldRoute) {
        this.findActiveLink()
      }
    }
  }

</script>
<style>
.powered-by {
  text-align: center;
  margin: 100px auto 0;
  bottom: 0px;
  position: relative;
}

.fiveguys {
  padding-top: 0 !important;
}
</style>



// WEBPACK FOOTER //
// SideBar.vue?37521f59